import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import styles from "./hero.module.css"

const Hero = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "hero.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2119) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      heroMobile: file(relativePath: { eq: "hero-mobile.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <BackgroundImage
      Tag="section"
      fluid={[
        {
          ...data.heroMobile.childImageSharp.fluid,
          media: `(max-width: 599px)`,
        },
        {
          ...data.hero.childImageSharp.fluid,
          media: `(min-width: 600px)`,
        },
      ]}
      className={styles.heroImage}
      backgroundColor="#4cd7b4"
    >
      <div className={styles.overlay}>
        <div className="wrapper">
          <div className={styles.hero}>
            <h1 class="h2">
              Benefício financeiro para o funcionário <br />{" "}
              <span className={styles.secondHeadline}>
                Produtividade para a empresa
              </span>
            </h1>
            <ul>
              <li>
                <Link className="btn secondary" to="/empresas">
                  Empresas
                </Link>
              </li>
              <li>
                <Link className="btn primary" to="/funcionarios">
                  Funcionários
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.targets}></div>
        </div>
      </div>
    </BackgroundImage>
  )
}

export default Hero
